import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderUserComponent } from '../header-user/header-user.component';
import { SessionStorageService } from '../../services/session-storage.service';
import { NotificationService } from '../../services/notification.service';

import { CartService } from '../../services/cart.service';
import { GalaxyButtonDirective } from '../../directives/galaxy-button.directive';
import { GalaxyRippleDirective } from '../../directives/galaxy-ripple.directive';
import { GalaxyCardComponent } from '../ui/galaxy-card/galaxy-card.component';
import { InteractiveCrystalDirective } from '@app/directives/interactive-crystal.directive';
import { GalaxySkeletonComponent } from '../ui/galaxy-skeleton/galaxy-skeleton.component';

@Component({
  selector: 'app-payment-success',
  imports: [
    HeaderUserComponent,
    GalaxyButtonDirective,
    GalaxyRippleDirective,
    GalaxyCardComponent,
    InteractiveCrystalDirective,
    GalaxySkeletonComponent,
  ],
  templateUrl: './payment-success.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./payment-success.component.css'],
})
export class PaymentSuccessComponent implements OnInit {
  isLoading = true;
  paymentSuccessful = false;
  message: string = '';
  orderId: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sessionStorage: SessionStorageService,
    private notificationService: NotificationService,
    private cartService: CartService,
  ) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      const paymentStatus = params.get('payment_status');
      this.orderId = params.get('orderId');

      if (paymentStatus === 'success') {
        this.handleSuccess();
      } else if (paymentStatus === 'error') {
        const errorMessage =
          params.get('message') || 'No se pudo procesar el pago.';
        this.handleError(errorMessage);
      } else {
        // Esto puede pasar si el usuario navega a la URL directamente sin parámetros
        this.isLoading = false;
        this.message = 'Página no encontrada o estado de pago inválido.';
        this.paymentSuccessful = false;
      }
    });
  }

  private handleSuccess(): void {
    this.paymentSuccessful = true;
    this.isLoading = false;
    this.message = `¡Gracias por tu compra! Tu pago ha sido confirmado y tu pedido #${this.orderId} está siendo procesado.`;
    this.notificationService.showSuccess(
      'Pago Confirmado',
      'Tu orden ha sido procesada exitosamente.',
    );

    // Limpiar el carrito y el estado de la sesión
    this.cartService.clearCart();
    this.sessionStorage.removeItem('orderId');
  }

  private handleError(errorMessage: string): void {
    this.paymentSuccessful = false;
    this.isLoading = false;
    this.message = `Hubo un error al confirmar tu pago: ${errorMessage}. Por favor, contacta a nuestro equipo de soporte.`;
    this.notificationService.showError(
      'Fallo en la Confirmación',
      'No se pudo confirmar el pago.',
    );
  }

  navigateToHome(): void {
    this.router.navigate(['/']);
  }

  navigateToOrderHistory(): void {
    this.router.navigate(['/order-history']);
  }
}
